import {ResourceConfig} from "@hidat/huijs-resource";
import {LibraryBaseFields, LibraryBaseInterface} from "./library-base.interface";
import {AnyHash, FieldConfig, FieldDataTypes, uNumber, uString} from "@hidat/huijs-common";

export const LibraryConfig = new ResourceConfig('Library', 'libraries', true, true)
  .addFields(LibraryBaseFields)
  .addFields([
    new FieldConfig('defaultUsageCode'),
    new FieldConfig('defaultUploaderId', FieldDataTypes.INTEGER),
  ])
  .setSorts({
    name: 'name'
  })
  .setDefaultSort('name');

export interface LibraryInterface extends LibraryBaseInterface {
  defaultUsageCode: uString;
  defaultUploaderId: uNumber;
}
